module.exports = __webpack_public_path__ + "static/assets/20f0289c0f6bed2c8246467e13e3ecb3.png";